import { IntegrationTypeEnum } from 'app/_models/integrationType';

export interface SaveHoldingIntegration {
    integrationId: string;
    holdingId: number;
    integrationType: IntegrationTypeEnum;
    isAutomatic: boolean;
    hasHeader: boolean;
    delimiter: string;
    partNameIndex: number;
    brandIndex: number;
    brandIdIndex: number;
    discountIndex: number;
    quantityIndex: number;
    partFactoryNumberIndex: number;
    partNumberIndex: number;
    partTypeIdIndex: number;
    priceIndex: number;
    senderEmails: string[];
    responseEmails: string[];
}

export function holdingIntegrationForEditFactory(
    integrationId: string,
    holdingId: number,
    integrationType: IntegrationTypeEnum,
    isAutomatic: boolean,
    hasHeader: boolean,
    delimiter: string,
    partNameIndex: number,
    brandIndex: number,
    brandIdIndex: number,
    discountIndex: number,
    quantityIndex: number,
    partFactoryNumberIndex: number,
    partNumberIndex: number,
    partTypeIdIndex: number,
    priceIndex: number,
    senderEmails: string[],
    responseEmails: string[]
): SaveHoldingIntegration {
    return {
        integrationId,
        holdingId: Number(holdingId),
        integrationType: Number(integrationType),
        isAutomatic,
        hasHeader,
        delimiter,
        partNameIndex: Number(partNameIndex),
        brandIndex: Number(brandIndex),
        brandIdIndex: Number(brandIdIndex),
        discountIndex: Number(discountIndex),
        quantityIndex: Number(quantityIndex),
        partFactoryNumberIndex: Number(partFactoryNumberIndex),
        partNumberIndex: Number(partNumberIndex),
        partTypeIdIndex: Number(partTypeIdIndex),
        priceIndex: Number(priceIndex),
        senderEmails,
        responseEmails
    }
};
